import UserTable from "@/app/app-shared/user/users-table";

const Users = () => {
  return <UserTable />;
};

export default Users;
